import React, { useState, useEffect } from "react";
import axios from "axios";
import Invoice from "./Invoice";
import routes from "../../../app/routes";

export default function List({ enterpriseId, enterpriseTeamId }) {
  const [collection, setCollection] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const updateCollection = () => {
    setLoaded(true);
    axios
      .get(routes.api.member_cycle_invoices.list + `?q[terminated_eq]=true`)
      .then((resp) => {
        setCollection(resp.data.data);
        setLoaded(false);
      });
  };

  useEffect(() => {
    updateCollection();
  }, []);

  return (
    <>
      {loaded && <p className="text-center mt20">Processing...</p>}
      {!loaded && (
        <div className="paymentInvoice_content">
          {collection.map((invoice, index) => {
            return <Invoice key={index} invoice={invoice} />;
          })}
        </div>
      )}
    </>
  );
}

